<template>
  <div>
    <vue-portal to="hrsys-navbar-actions">
      <div class="flex">
        <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
          <base-button @click="createPayment" class="self-end px-3" icon="plus" type="border"/>
        </vx-tooltip>
      </div>
    </vue-portal>

    <div class="view-container">
      <base-loader :loading="loadingContent">
        <base-search @search="search" v-model="queryParams.search"/>

        <payments-table :header="tableHeader"
                        :payments="payments"
                        :show-project-info="true"
                        @refresh="getPaymentInfo"
        />

        <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
      </base-loader>
    </div>
  </div>
</template>

<script>
  import PaymentsTable from "../../components/payments/PaymentsTable";
  import Payments from "../../services/Payments";
  import Pagination from '../../components/Pagination';
  import EventBus from "../../utilities/eventBus";

  export default {
    name: 'ProjectFinance',
    components: {
      PaymentsTable,
      Pagination,
    },
    data () {
      return {
        pagination: {},
        queryParams: {
          page: 1,
          search: '',
          include: 'project.client'
        },
        payments: [],
        projectId: null,
        loadingContent: false
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('payments.table.project'),
          this.$t('payments.table.amount'),
          this.$t('payments.table.status'),
          this.$t('payments.table.sent_at'),
          this.$t('payments.table.paid_at'),
          this.$t('payments.table.actions'),
        ])
      },
    },
    methods: {
      getPaymentInfo () {
        this.loadingContent = true;
        Payments.list(this.queryParams).then((response) => {
          this.payments = response.data;
          this.pagination = response.meta.pagination
        }).finally(() => {
          this.loadingContent = false;
        });
      },
      createPayment () {
        EventBus.$emit('openCreatePaymentModal', {});
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        });
        this.queryParams.page = 1;
        this.getPaymentInfo();
      },
      changePage (newPage) {
        this.queryParams.page = newPage;
        this.$router.push({query: this.queryParams}).catch(() => {
        });
        this.getPaymentInfo();
      },
    },
    beforeDestroy () {
      EventBus.$off('paymentCreated');
    },
    mounted () {
      this.projectId = parseInt(this.$route.params.id);
      this.getPaymentInfo();
      EventBus.$on('paymentCreated', () => {
        this.getPaymentInfo();
      });
    }
  }
</script>

<style scoped>

</style>
